export class UploadModel {
  file?: any;
  name?: string;
  basedir: string = '/';
  base64?: string;
  selected: boolean = true;

  public static fromJson(props: any) {
    let data = new UploadModel();
    data.file = props.file;
    data.name = props.name;
    return data;
  }

  public toJson() {
    return {
      file: this.file,
      name: this.name,
      base64: this.base64,
      basedir: this.basedir,
    };
  }

  public static fromFile(file_data: any) {
    let file_struct: UploadModel = new UploadModel();
    file_struct.file = file_data;
    file_struct.name = file_struct.file.name;
    return file_struct;
  }

  public getBase64() {
    return new Promise((resolve) => {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        let arr = e.target.result.split(',');
        this.base64 = arr[1];
        resolve('');
      };
      if (this.file) reader.readAsDataURL(this.file);
    });
  }

  public read_text_file(): Promise<string> {
    return new Promise((resolve) => {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        console.log(e);

        resolve(e.target.result);
      };
      if (this.file) reader.readAsText(this.file);
    });
  }

  public read_form_data() {
    let form_data = new FormData();
    form_data.append('file', this.file);
    form_data.append('name', this.name);
    return form_data;
  }
}
